<section class="system-content-header" *ngIf="showContentHeader">
  <!-- Skeleton Loading State -->
  <div class="header-main" *ngIf="loading">
    <div class="title-group">
      <ejs-skeleton shape="Rectangle" width="420px" height="36px" cssClass="title-skeleton"></ejs-skeleton>
      <ejs-skeleton shape="Text" width="520px" height="17px" cssClass="subtitle-skeleton"></ejs-skeleton>
    </div>

    <nav class="breadcrumb-nav breadcrumb-skeleton" aria-label="Navegação da página">
      <div class="breadcrumb-skeleton-items">
        <ejs-skeleton shape="Circle" width="12px" height="12px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="6px" height="12px" cssClass="breadcrumb-separator-skeleton"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="68px" height="14px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="6px" height="12px" cssClass="breadcrumb-separator-skeleton"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="120px" height="14px"></ejs-skeleton>
      </div>
    </nav>
  </div>

  <!-- Loaded Content -->
  <div class="header-main" *ngIf="!loading">
    <div class="title-group">
      <h1 class="page-title">{{ title }}</h1>
      <p class="page-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>

    <nav class="breadcrumb-nav" aria-label="Navegação da página">
      <ejs-breadcrumb cssClass="system-breadcrumb" (itemClick)="onBreadcrumbClick($event)" [enableNavigation]="false">
        <e-breadcrumb-items>
          <e-breadcrumb-item [iconCss]="' fas fa-home'" [url]="'/'"></e-breadcrumb-item>
          @for (p of contentsPath; track p.path; let isLast = $last) {
            @if (isLast) {
            <e-breadcrumb-item [text]="p.name | replaceParams: contentId"></e-breadcrumb-item>
            } @else {
            <e-breadcrumb-item [text]="p.name | replaceParams: contentId" [url]="p.path"></e-breadcrumb-item>
            }
          }
        </e-breadcrumb-items>
      </ejs-breadcrumb>
    </nav>
  </div>
</section>